import { render, staticRenderFns } from "./visible-weight.vue?vue&type=template&id=4df36cfb&scoped=true"
import script from "./visible-weight.vue?vue&type=script&lang=js"
export * from "./visible-weight.vue?vue&type=script&lang=js"
import style0 from "./visible-weight.vue?vue&type=style&index=0&id=4df36cfb&prod&lang=css"
import style1 from "./visible-weight.vue?vue&type=style&index=1&id=4df36cfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df36cfb",
  null
  
)

export default component.exports